import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiSetupYCPDeliveryMethod,
    type OpenApiSetupYCPDeliveryRequest,
    type OpenApiSetupYCPDeliveryResponseSuccess,
    OpenApiSetupYCPDeliveryUrl,
} from '#shared/api/schema';

const api = createApi({
    name: 'entities/integration/api/ycpApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            setup: builder.mutation<OpenApiSetupYCPDeliveryResponseSuccess, OpenApiSetupYCPDeliveryRequest>({
                query: () => {
                    return {
                        url: OpenApiSetupYCPDeliveryUrl,
                        method: OpenApiSetupYCPDeliveryMethod,
                    };
                },
            }),
        };
    },
});

export const useIntegrationYcpSetup = api.useSetupMutation;
